import React, { useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import PropTypes from "prop-types";
import Modal from "@mui/material/Modal";
import pointBrand from "../../../assets/images/icons/catering-icons/ic-my-points.svg";
import { useAuth } from "context";
import Box from "@mui/material/Box";
import SimpleBackdrop from "components/MDLoader_Backdrop";
import EmailModal from "layouts/dashboard/components/EmailModal";
import OTPInput from "layouts/dashboard/components/Otp";
import { sendOtp } from "layouts/dashboard/_request";
import { verifyOtp } from "layouts/dashboard/_request";

const EmailCustomModal = ({
  title,
  subtitle,
  subtitle2,
  icon,
  handleClose,
  open,
  color,
  userEmail,
  loader,
  onConfirm,
  description,
  isIcon,
  setSelectedValue,
  selectedValue,
  status,
  setStatus,
  otp,
  setOtp,
}) => {
  const { darkMode, showSnackbarWithMessage } = useAuth();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "90%", xl: "40%" },
    bgcolor: !darkMode ? "background.paper" : "#202940",
    boxShadow: 10,
    p: { xs: 2, xl: 4 },
    borderRadius: 2,
  };
  const handleSendOtp = async () => {
    try {
      if (selectedValue) {
        const {
          data: { success, message },
        } = await sendOtp(selectedValue);
        if (success) {
          showSnackbarWithMessage({
            type: "success",
            message: message,
          });
          setStatus({
            isOTPVisible: true,
          });
        } else {
          showSnackbarWithMessage({
            type: "error",
            message,
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };
  const handleVerifyOtp = async () => {
    try {
      if (otp) {
        const {
          data: { success, message },
        } = await verifyOtp(otp);
        if (success) {
          onConfirm();
        } else {
          showSnackbarWithMessage({
            type: "error",
            message,
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const resetOTP = () => {
    setStatus({
      isOTPVisible: false,
    });
    setOtp("");
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={style}>
          <card>
            <MDBox pt={1} px={1}>
              {isIcon && (
                <MDBox
                  variant="gradient"
                  bgColor={color}
                  color={color === "light" ? "dark" : "white"}
                  coloredShadow={color}
                  borderRadius="xl"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  width="4rem"
                  height="4rem"
                  mt={-8}
                  mb={4}
                  position="relative"
                  left={"45%"}
                >
                  <MDBox component="img" src={pointBrand} alt="pointBrand" width="2rem" />
                </MDBox>
              )}
              <MDBox lineHeight={1}>
                <MDTypography variant="button" fontWeight="light" color="text">
                  {title}
                  {subtitle}
                </MDTypography>
              </MDBox>
              <MDBox lineHeight={1}>
                <MDTypography variant="button" fontWeight="light" color="text">
                  {subtitle2}
                </MDTypography>
              </MDBox>
              <EmailModal
                setSelectedValue={setSelectedValue}
                selectedValue={selectedValue}
                resetOTP={resetOTP}
              />
              {status.isOTPVisible && (
                <MDBox sx={{ marginTop: "15px", marginBottom: "5px" }}>
                  <OTPInput otp={otp} setOtp={setOtp} />
                </MDBox>
              )}
              <MDTypography fontWeight="light" color="text" sx={{ fontSize: "14px", mt: 2 }}>
                {description}
              </MDTypography>
              <MDTypography fontWeight="light" color="text" sx={{ fontSize: "14px", mt: 2 }}>
                {!status.isOTPVisible &&
                  selectedValue &&
                  "Please click on the 'Send Verification Code' button to verify your email."}
              </MDTypography>
              <MDBox
                textAlign="right"
                pt={2}
                sx={{ display: "flex", gap: 2, justifyContent: "end" }}
              >
                <MDButton
                  variant="outlined"
                  color={"success"}
                  size="medium"
                  onClick={() => {
                    handleClose();
                    setSelectedValue("");
                  }}
                  sx={{ textTransform: "none" }}
                >
                  {"Cancel"}
                </MDButton>
                {otp.length === 6 && (
                  <MDButton
                    variant="gradient"
                    color={"success"}
                    size="medium"
                    disabled={loader}
                    onClick={() => handleVerifyOtp()}
                    sx={{ textTransform: "none" }}
                  >
                    {"Confirm"}
                  </MDButton>
                )}
                {!status.isOTPVisible && selectedValue && (
                  <MDButton
                    variant="gradient"
                    color={"success"}
                    size="medium"
                    disabled={loader}
                    onClick={() => handleSendOtp()}
                    sx={{ textTransform: "none" }}
                  >
                    Send Verification Code
                  </MDButton>
                )}
              </MDBox>
            </MDBox>
          </card>
        </Box>
      </Modal>
      {loader && <SimpleBackdrop />}
    </>
  );
};

EmailCustomModal.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  subtitle: PropTypes.string,
  subtitle2: PropTypes.string,
  userEmail: PropTypes.string,
  onConfirm: PropTypes.func,
  loader: PropTypes.bool,
  description: PropTypes.string,
  isIcon: PropTypes.bool,
  setSelectedValue: PropTypes.any,
  selectedValue: PropTypes.string,
  setStatus: PropTypes.any,
  status: PropTypes.any,
  otp: PropTypes.string,
  setOtp: PropTypes.any,
};

export default EmailCustomModal;
